import React from 'react';

import Accessibility from '../icons/Accessibility';
import Alert from '../icons/Alert';
import Arrow from '../icons/Arrow';
import Bear from '../icons/Bear';
import Calendar from '../icons/Calendar';
import Cart from '../icons/Cart';
import CartError from '../icons/CartError';
import CartV2 from '../icons/CartV2';
import CheckIcon from '../icons/CheckIcon';
import Chevron from '../icons/Chevron';
import Clock from '../icons/Clock';
import Close from '../icons/Close';
import ColorSwatch from '../icons/ColorSwatch';
import Confirm from '../icons/Confirm';
import Document from '../icons/Document';
import Exclamation from '../icons/Exclamation';
import ExternalLinkIcon from '../icons/ExternalLink';
import Filter from '../icons/Filter';
import Hamburger from '../icons/Hamburger';
import LinkPin from '../icons/Link';
import Location from '../icons/Location';
import Lock from '../icons/Lock';
import Logo from '../icons/Logo';
import Logo2 from '../icons/Logo2';
import LogoRainbow from '../icons/LogoRainbow';
import Minus from '../icons/Minus';
import Pin from '../icons/Pin';
import Play from '../icons/Play';
import Plus from '../icons/Plus';
import Profile from '../icons/Profile';
import Refresh from '../icons/Refresh';
import Search from '../icons/Search';
import Share from '../icons/Share';
import Star from '../icons/Star';
import Stars from '../icons/Stars';
import Tooltip from '../icons/Tooltip';

const renderIcon = icon => {
	if (!icon) return null;

	switch (icon) {
	case 'alert':
		return <Alert />;
	case 'arrow':
		return <Arrow />;
	case 'accessibility':
		return <Accessibility />;
	case 'bear':
		return <Bear />;
	case 'calendar':
		return <Calendar />;
	case 'cart':
		return <Cart />;
	case 'cartV2':
		return <CartV2 />;
	case 'cart-error':
		return <CartError />;
	case 'check-icon':
		return <CheckIcon />;
	case 'clock':
		return <Clock />;
	case 'chevron':
		return <Chevron />;
	case 'close':
		return <Close />;
	case 'confirm':
		return <Confirm />;
	case 'color-swatch':
		return <ColorSwatch />;
	case 'document':
		return <Document />;
	case 'exclamation':
		return <Exclamation />;
	case 'external-link':
		return <ExternalLinkIcon />;
	case 'filter':
		return <Filter />;
	case 'hamburger':
		return <Hamburger />;
	case 'logo':
		return <Logo />;
	case 'link':
		return <LinkPin />;
	case 'location':
		return <Location />;
	case 'lock':
		return <Lock />;
	case 'logo2':
		return <Logo2 />;
	case 'minus':
		return <Minus />;
	case 'pin':
		return <Pin />;
	case 'play':
		return <Play />;
	case 'plus':
		return <Plus />;
	case 'profile':
		return <Profile />;
	case 'rainbow':
		return <LogoRainbow />;
	case 'search':
		return <Search />;
	case 'stars':
		return <Stars />;
	case 'star':
		return <Star />;
	case 'refresh':
		return <Refresh />;
	case 'share':
		return <Share />;
	case 'tooltip':
		return <Tooltip />;
	default:
		return null;
	}
};

export default renderIcon;
